import styled from 'styled-components';

/**
 * The row's action as a text link, red and underlined like View Location /
 * View Brand. TextButton is 100% wide and 30px tall by default, which would
 * stretch it over the row and pad the card; shrink it to its words. Class
 * plus element, so it also beats TextButton's own phone font sizes.
 */
export const RowAction = styled.span`
  display: inline-flex;

  button {
    width: auto;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
  }
`;
